export default "__VITE_ASSET__BxNMa9KF__"